import { render, staticRenderFns } from "./configReposicionFile.vue?vue&type=template&id=73d9f516&scoped=true"
import script from "./configReposicionFile.vue?vue&type=script&lang=js"
export * from "./configReposicionFile.vue?vue&type=script&lang=js"
import style0 from "./configReposicionFile.vue?vue&type=style&index=0&id=73d9f516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d9f516",
  null
  
)

export default component.exports